import React, { useEffect, useMemo, useState } from "react";
import PageWrapper, { PageHero } from "../components/PageWrapper";
import api from "../lib/api";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "../components/ui/accordion";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => {});
  }, []);

  const categories = useMemo(() => {
    const set = new Set(faqs.map((f) => f.category).filter(Boolean));
    return ["All", ...Array.from(set)];
  }, [faqs]);

  const filtered =
    activeCategory === "All"
      ? faqs
      : faqs.filter((f) => f.category === activeCategory);

  return (
    <PageWrapper testId="faq-page">
      <PageHero
        eyebrow="FAQ"
        title="Questions institutional leaders ask us most often."
        description="If you don't find what you need, our institutional team is one form away."
      />

      <section className="bg-white py-24 sm:py-28">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12">
          {categories.length > 1 ? (
            <div
              data-testid="faq-category-tabs"
              className="flex flex-wrap gap-2 mb-10"
            >
              {categories.map((c) => (
                <button
                  key={c}
                  data-testid={`faq-category-${c.toLowerCase()}`}
                  onClick={() => setActiveCategory(c)}
                  className={`px-5 py-2.5 text-xs uppercase tracking-[0.18em] font-semibold transition ${
                    activeCategory === c
                      ? "bg-navy text-white"
                      : "bg-white text-navy border border-slate-200 hover:border-navy"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          ) : null}

          <Accordion type="single" collapsible data-testid="faq-accordion">
            {filtered.map((f, i) => (
              <AccordionItem
                key={f.id || i}
                value={f.id || String(i)}
                className="border-b border-slate-200"
              >
                <AccordionTrigger
                  data-testid={`faq-q-${i}`}
                  className="py-6 text-left hover:no-underline group"
                >
                  <div className="flex items-start gap-4 w-full">
                    <span className="font-display text-sm uppercase tracking-[0.18em] text-gold-500 pt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-lg sm:text-xl text-navy group-hover:text-gold-500 transition pr-4">
                      {f.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="pl-12 pb-6 text-slate-600 leading-relaxed text-base">
                    {f.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </PageWrapper>
  );
}
